import type { Course } from '../lib/types';
import { formatMinutes, formatPrice } from '../lib/progress';
import { Badge, ButtonLink, Icon, ProgressBar } from './ui';

export function courseImage(course: Pick<Course, 'image_path'>): string {
  return course.image_path || '/blueline-seal.png';
}

export function CourseCard({ course, progress }: { course: Course; progress?: number }) {
  const enrolled = typeof progress === 'number';
  const done = enrolled && progress >= 100;
  return (
    <article className="course-card">
      <img className="media" src={courseImage(course)} alt="" loading="lazy" />
      <div className="body">
        {course.is_demo && <span><Badge tone="warning">Demo course</Badge></span>}
        <h3>{course.title}</h3>
        {course.subtitle && <p className="small muted" style={{ margin: 0 }}>{course.subtitle}</p>}
        <p className="small muted row" style={{ margin: 0, gap: 12 }}>
          {course.duration_minutes ? <span className="row" style={{ gap: 4 }}><Icon name="clock" />{formatMinutes(course.duration_minutes)}</span> : null}
          {course.pdh ? <span className="row" style={{ gap: 4 }}><Icon name="award" />{course.pdh} PDH</span> : null}
        </p>
        <div className="foot">
          {enrolled
            ? <ProgressBar value={progress} label={done ? 'Completed' : 'Progress'} size="sm" />
            : <span className="price">{course.price_cents ? formatPrice(course.price_cents, course.currency) : 'Free'}</span>}
          {done ? <ButtonLink to="/certificates" variant="secondary" icon="award">View certificate</ButtonLink>
            : enrolled ? <ButtonLink to={`/learn/${course.slug}`} iconAfter="chevronRight">{progress > 0 ? 'Resume course' : 'Start course'}</ButtonLink>
            : <ButtonLink to={`/courses/${course.slug}`} variant="enroll">View course</ButtonLink>}
        </div>
      </div>
    </article>
  );
}
